import React, { useState } from "react";
import {
  Box,
  Button,
  ButtonBase,
  Grid,
  IconButton,
  Typography,
  ListItem,
  ListItemButton,
  List,
  ListItemIcon,
  ListItemText,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import img from "./cardImg.png";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SelectDishes1 from "../SelectDishes1/SelectDishes1";
import SelectDishesCards from "../SelectDishes1/SelectDishes1Cards";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import MealPlan from "./MealPlan";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { addDish, removeAllDish, selectAllDishes, updateQuantity } from "store/Reducers/DishSlice";
import { IMAGE_URL } from "config";

const data = [
  {
    id: "1",
    title: "Main Course",
    image: "/cardImg.png",
    subTitle: "20 Dishes Selected",
    EditbtnProp: "block",
    incDecBtnProp: "flex",
    subTitleProp: "block",
    selectBtnProp: "none",
  },
  {
    id: "2",
    title: "Salad dishes",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "block",
    incDecBtnProp: "flex",
    subTitleProp: "block",
    selectBtnProp: "none",
  },
  {
    id: "3",
    title: "Starter",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "none",
    incDecBtnProp: "none",
    subTitleProp: "none",
  },
  {
    id: "4",
    title: "Sweet dishes",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "none",
    incDecBtnProp: "none",
    subTitleProp: "none",
  },
  {
    id: "5",
    title: "Desert",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "none",
    incDecBtnProp: "none",
    subTitleProp: "none",
  },
  {
    id: "6",
    title: "Starter",
    image: { img },
    subTitle: "20 Dishes Selected",
    EditbtnProp: "none",
    incDecBtnProp: "none",
    subTitleProp: "none",
  },
];

const MealPlaneCard = ({ dishesData }) => {
  // console.log(price);
  // const [value, setValue] = useState("1");
  const [selectAll, setSelectAll] = useState(false);
  // const { data: menu, isLoading } = useGetMenuByIdQuery(id);
  const [getDishesIndex, setGetDishesIndex] = useState(0);
  const [dishes, setDishes] = useState([]);
  const [menuData, setMenuData] = useState([]);
  const { selectedDishes } = useSelector((state) => state.dishes);

  console.log("selectedDishes", selectedDishes);
  // const newCart = []
  // for (const i of selectedDishes) {
  //   console.log(i);

  //   // Using spread operator for objects
  //   let obj = { ...i?.dish, price: price };

  //   // Alternatively, using object shorthand syntax
  //   // let obj = { ...i, id: 2 };
  //   newCart.push(obj)
  //   console.log(obj);
  // }
  // localStorage.setItem("newCart", JSON.stringify(newCart))

  const [dishSidebr, setDishSidebr] = useState(false);

  const [state, setState] = React.useState({
    right: false,
  });
  const [buttonShowId, setbuttonShowId] = useState(false)

  const [showIncDec, setshowIncDec] = useState([])
  const addToCart = (dish, quantity) => {
    const ShowIncDec = () => {
      const filterObj = dishesData.filter((item) => item._id == dish._id)
      console.log("filterObj", filterObj)
      setshowIncDec(filterObj)
    }
    ShowIncDec()
    let newObject = { ...dish, selected: true };
    // console.log("dish", dish)
    console.log("newObject", newObject)
    // setbuttonShowId(dish._id)
    setTimeout(() => {
      if (newObject !== undefined) {
        dispatch(addDish(newObject));
      } else {
        console.log("some error")
      }
    }, 1000);
  };

  const updateCartQuantity = (dish, quantity) => {
    // const filterAddOn = selectedDishes.filter((item) => item.dish._id === dish._id)
    // console.log("filterAddOn", filterAddOn);

    // if (filterAddOn[0].quantity > 1) {
    dispatch(updateQuantity({ dish }));
    // }

  };



  const handleSelectAllChange = (event) => {
    if (event.target.checked === true) {
      setSelectAll(true)
      console.log("true")
      dispatch(selectAllDishes(dishesData))
    }
    else {
      dispatch(removeAllDish(dishesData))
      setSelectAll(false);
    }
  };

  const handleSelectDishesChange = (event, v) => {
    const { checked } = event.target;
    let find = dishes.find((x) => x._id === v._id);
    if (find) {
      if (checked) {
        find.checked = true;

        if (menuData.selectedDishes.length === dishes.length) {
          setSelectAll(true);
        }
        let t = { ...menuData };
        t.selectedDishes.push(v._id);
        setMenuData(t);
        setDishes([...dishes]);
      } else {
        find.checked = false;
        setSelectAll(false);
        menuData.selectedDishes = menuData.selectedDishes.filter(
          (x) => x !== v._id
        );
        setDishes([...dishes]);
      }
    }
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width:
          anchor === "top" || anchor === "bottom"
            ? "auto"
            : { lg: "708px", md: "708px", sm: "auto", xs: "auto" },
        paddingRight: { lg: "24px", md: "24px", sm: "24px", xs: "0px" },
      }}
      role="presentation"
    // onClick={toggleDrawer(anchor, false)}
    // onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box
        sx={{
          paddingLeft: "24px",
          paddingBottom: "24px",
          // border: "1px solid red"
        }}
      >
        <Box>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                sx={{
                  width: "20px",
                  height: "76px",
                  fontSize: { lg: "24px", md: "24px", sm: "22px", xs: "18px" },
                  fontWeight: "600",
                  fontSize: "24px",
                }}
              >
                <ListItemIcon>
                  <CloseIcon
                    sx={{ color: "#E75C62" }}
                    onClick={toggleDrawer(anchor, false)}
                    onKeyDown={toggleDrawer(anchor, false)}
                  />
                  <ListItemText
                    sx={{
                      paddingRight: {
                        lg: "246px",
                        md: "246px",
                        sm: "246px",
                        xs: "40px",
                      },
                      color: "#000000",
                    }}
                    color="#000000"
                  />{" "}
                  Select Dishes
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>

        <Box
          // component={"container"}
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "block",
              lg: "block",
            },
            backgroundImage: "url(./images/selectdish1.png)",
            backgroundRepeat: "no-repeat",

            width: { lg: "100%", md: "100%", sm: "686px", xs: "95%" },
            height: {
              xl: "357.47px",
              lg: "357.47px",
              md: "310px",
              // md: "800px",
              sm: "310px",
              xs: "200px",
            },
            backgroundSize: {
              lg: "contain",
              md: "cover",
              sm: "contain",
              xs: "cover",
            },
            borderRadius: "6px",
            // backgroundPosition: "center",
          }}
        >
          <Box sx={{}}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                // paddingRight: "24px",
                // paddingLeft: "16px",
                color: "#FFFFFF",
                paddingTop: {
                  lg: "195px",
                  md: "195px",
                  sm: "210px",
                  xs: "100px",
                },

                height: { lg: "115px", md: "115px", sm: "100px", xs: "100px" },
                borderRadius: "6px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  width: { lg: "100%", md: "100%", sm: "686px", xs: "100%" },
                  justifyContent: "space-between",
                  background:
                    "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
                  borderRadius: "6px",
                }}
              >
                <Box sx={{ paddingLeft: "16px", paddingTop: "6px" }}>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "24px",
                          md: "24px",
                          sm: "20px",
                          xs: "18px",
                        },
                        fontWeight: "600",
                      }}
                    >
                      Main Course
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "18px",
                          md: "18px",
                          sm: "16px",
                          xs: "12px",
                        },
                        fontWeight: "400",
                        paddingTop: "5px",
                      }}
                    >
                      Choose your prefered dishes
                    </Typography>
                    <Box
                      sx={{
                        paddingTop: {
                          lg: "8px",
                          md: "8px",
                          sm: "8px",
                          xs: "4px",
                        },
                        color: "#E75C62",
                        paddingLeft: "14px",
                        height: {
                          lg: "24px",
                          md: "24px",
                          sm: "16px",
                          xs: "12px",
                        },
                      }}
                    >
                      <ErrorIcon
                        sx={{
                          width: {
                            lg: "24px",
                            md: "24px",
                            sm: "16px",
                            xs: "14px",
                          },
                          height: {
                            lg: "24px",
                            md: "24px",
                            sm: "16px",
                            xs: "14px",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    paddingRight: "24px",
                    paddingTop: {
                      lg: "60px",
                      md: "60px",
                      sm: "50px",
                      xs: "40px",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "18px",
                        md: "18px",
                        sm: "16px",
                        xs: "12px",
                      },
                      fontWeight: "600",
                    }}
                  >
                    6/30 Dishes
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box>
          <SelectDishesCards />
        </Box>

        <Box height="96px" sx={{ backgroundColor: "#ffffff" }}>
          <Box
            sx={{
              paddingTop: "20px",
              paddingRight: { lg: "0px", md: "0px", sm: "20px", xs: "20px" },
            }}
          >
            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{
                textTransform: "capitalize",
                fontSize: { lg: "16px", md: "16px", sm: "10px", xs: "10px" },
                fontWeight: "600",
                height: "48px",
                marginBottom: "24px",
                // position: 'sticky',
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );

  const dispatch = useDispatch();


  return (
    <Box>
      <Box sx={{ margin: { lg: "30px", md: "20px", sm: "20px", xs: "0px" } }}>
        <Box sx={{ mb: "20px" }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "32px",
            }}
          >
            Meal Plan
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  checked={selectAll}
                  onChange={handleSelectAllChange}
                />
              }
              label="Select all"
            />
          </FormGroup>
        </Box>
        <Grid container spacing={3}>
          {dishesData &&
            dishesData?.map((v, index) => {
              // let innerLoopExecuted = false;
              console.log(v)
              return (
                <>
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Box sx={{ maxWidth: "20%" }}>
                        <img src={IMAGE_URL + v.image} style={{ width: "100%" }} />
                      </Box>
                      <Box>
                        <Box sx={{ ml: "10px" }}>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              fontSize: "20px",
                            }}
                          >
                            {v.name}
                          </Typography>
                          {selectedDishes.map((item) => {
                            return (
                              <>
                                {item?.dish?._id === v?._id && (
                                  <Typography
                                    sx={{
                                      color: "#545359",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                      display: `block`,
                                      // border:"1px solid red"
                                    }}
                                  >
                                    {item?.quantity} Selected
                                  </Typography>
                                )}
                              </>
                            );
                          })}
                        </Box>
                        {
                          showIncDec.length > 0 &&
                            showIncDec[0]._id === v._id ?
                            <Box
                              sx={{
                                display: `flex`,
                                flexDirection: "row",
                                alignItems: "center",
                                ml: "10px",
                                mt: "5px",
                                // border: "1px solid red"
                              }}
                            >
                              <Box>
                                <IconButton
                                  size="small"
                                  sx={{
                                    backgroundColor: "#F0FAF9",
                                    // backgroundColor: "red",
                                  }}
                                  value="minus"
                                  onClick={(e) => updateCartQuantity(v)}
                                >
                                  <RemoveIcon sx={{ color: "#2B817B" }} />
                                </IconButton>
                              </Box>
                              <Box sx={{ ml: "11px", mr: "11px" }}>
                                <Typography>
                                  {selectedDishes.length > 0 ?
                                    selectedDishes.map((item) => {
                                      return (
                                        <>
                                          {item?.dish?._id === v?._id && (
                                            <Typography
                                              sx={{
                                                color: "#545359",
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                display: `block`,
                                                // border: "1px solid red"
                                              }}
                                            >
                                              {item.quantity}
                                            </Typography>
                                          )
                                            // : (
                                            //   <Typography
                                            //     sx={{
                                            //       color: "#545359",
                                            //       fontWeight: "bold",
                                            //       fontSize: "15px",
                                            //       display: `block`,
                                            //       border: "1px solid red"
                                            //     }}
                                            //   >
                                            //     0
                                            //   </Typography>
                                            // )
                                          }
                                        </>
                                      )
                                    })
                                    : (<Typography
                                      sx={{
                                        color: "#545359",
                                        fontWeight: "bold",
                                        fontSize: "15px",
                                        display: `block`,
                                        // border: "1px solid red"
                                      }}
                                    >
                                      0
                                    </Typography>)
                                  }
                                </Typography>
                              </Box>
                              <Box>
                                <IconButton
                                  size="small"
                                  sx={{
                                    backgroundColor: "#F0FAF9",
                                  }}
                                  // aria-label="add"
                                  value="add"
                                  onClick={(e) => addToCart(v)}
                                >
                                  <AddIcon sx={{ color: "#2B817B" }} />
                                </IconButton>
                              </Box>
                            </Box> :
                            <Box sx={{
                              ml: "10px", mt: "30px",
                              // border: "1px solid red",
                              display: `${"block"}`,
                              // display: `${value?.dish?.selected ? "none" : "block"}`,
                            }}>
                              <Button
                                variant="outlined"
                                sx={{
                                  // border: "1px solid red"
                                }}

                                onClick={() => addToCart(v)}
                              >
                                Select
                              </Button>
                            </Box>
                        }


                        {/* {
                          selectedDishes.length > 0 ? (
                            selectedDishes.map((value, i) => {
                              if (
                                value.dish._id === v._id &&
                                !printedValues[i]?.includes(value)  // Corrected syntax here
                              ) {
                                printedValues.push(value)
                                //   if () {
                                // console.log("outer index", index)
                                console.log("printedValues", printedValues)
                                console.log("printedValues with i", printedValues[i])

                                return (

                                  <Box
                                    sx={{
                                      display: `flex`,
                                      flexDirection: "row",
                                      alignItems: "center",
                                      ml: "10px",
                                      mt: "5px",
                                    }}
                                  >
                                    <Box>
                                      <IconButton
                                        size="small"
                                        sx={{
                                          backgroundColor: "#F0FAF9",
                                          // backgroundColor: "red",
                                        }}
                                        value="minus"
                                        onClick={(e) => updateCartQuantity(v)}
                                      >
                                        <RemoveIcon sx={{ color: "#2B817B" }} />
                                      </IconButton>
                                    </Box>
                                    <Box sx={{ ml: "11px", mr: "11px" }}>
                                      <Typography>
                                        
                                        {selectedDishes.map((item) => {
                                          return (
                                            <>
                                              {item.dish._id === v._id && (
                                                <Typography
                                                  sx={{
                                                    color: "#545359",
                                                    fontWeight: 400,
                                                    fontSize: "15px",
                                                    display: `block`,
                                                    border: "1px solid red"
                                                  }}
                                                >
                                                  {item.quantity}
                                                </Typography>
                                              )}
                                            </>
                                          );
                                        })}
                                      </Typography>
                                    </Box>
                                    <Box>
                                      <IconButton
                                        size="small"
                                        sx={{
                                          backgroundColor: "#F0FAF9",
                                        }}
                                        // aria-label="add"
                                        value="add"
                                        onClick={(e) => addToCart(v)}
                                      >
                                        <AddIcon sx={{ color: "#2B817B" }} />
                                      </IconButton>
                                    </Box>
                                  </Box>
                                )
                              } else {
                                return (<Box sx={{
                                  ml: "10px", mt: "30px",
                                  border: "1px solid red",
                                  display: `${"block"}`,
                                  // display: `${value?.dish?.selected ? "none" : "block"}`,
                                }}>
                                  <Button
                                    variant="outlined"
                                    sx={{
                                      border: "1px solid red"
                                    }}

                                    onClick={() => addToCart(v)}
                                  >
                                    Select
                                  </Button>
                                </Box>)
                              }
                            })
                          ) : (
                            // !selectedDishes || selectedDishes.length < 1 &&
                            <Box sx={{ ml: "10px", mt: "30px" }}>
                              <Button
                                variant="outlined"
                                sx={{
                                  display: `${v.selectBtnProp}`,
                                  // border: "1px solid green"
                                }}
                                onClick={() => addToCart(v)}
                              >
                                Select Dishes
                              </Button>
                            </Box>
                          )
                        } */}
                      </Box>
                      <Box sx={{ ml: "10px", display: `${v.EditbtnProp}` }}>
                        <Button variant="text">Edit</Button>
                      </Box>
                    </Box>
                  </Grid >
                </>
              );
            })}
        </Grid>
        <Drawer
          anchor={"right"}
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
        >
          {list("right")}
        </Drawer>
      </Box>
    </Box >
  );
};

export default MealPlaneCard;
